import createLucideIcon from '../createLucideIcon';

const Grid = createLucideIcon('Grid', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['line', { x1: '3', x2: '21', y1: '9', y2: '9', key: '1vqk6q' }],
  ['line', { x1: '3', x2: '21', y1: '15', y2: '15', key: 'o2sbyz' }],
  ['line', { x1: '9', x2: '9', y1: '3', y2: '21', key: '13tij5' }],
  ['line', { x1: '15', x2: '15', y1: '3', y2: '21', key: '1hpv9i' }],
]);

export default Grid;
